<template src="./Edit.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        // this.$store.dispatch("lookups/getAllItemPriceList", "خدمات العيادة");
        this.$store.dispatch("lookups/getProcedures");
        this.$store.dispatch("lookups/getPaymentAccounts");

        this.$store
            .dispatch("doctorsAppointments/getForEdit", this.itemId)
            .then((res) => {
                this.appointment = res;
                this.$store.dispatch("doctorsStock/getMedicines", this.appointment.doctorId).then(res => {
                    this.medicinesList = res
                });
            }).catch(() => { });
    },
    computed: {
        itemPriceList() {
            return this.$store.state.lookups.itemPriceList || [];
        }, procedures() {
            return [{
                value: "خدمات قسم التجميل الجراحي",
                label: "خدمات قسم التجميل الجراحي"
            },
            {
                value: "خدمات قسم التجميل اللاجراحي",
                label: "خدمات قسم التجميل اللاجراحي"
            },
            {
                value: "خدمات قسم التغذية",
                label: "خدمات قسم التغذية"
            },
            {
                value: "خدمات قسم العناية بالبشرة",
                label: "خدمات قسم العناية بالبشرة"
            },
            {
                value: "خدمات قسم الليزر",
                label: "خدمات قسم الليزر"
            }]
            // return  this.$store.state.lookups.procedures.filter(x => x.value != "الاصول الثابتة" &&  x.value !=  "خدمات تحاليل")
        },

        paymentTypes() {
            return this.$store.state.lookups.paymentAccounts;
        },

        medicines() {
            return this.medicinesList;
        },
    },
    data() {
        return {
            medicinesList: [],
            procedureId: null,
            appointment: {
                fullName: null,
                fileNo: null,
                appointmentType: null,
                appointmentDate: null,
                services: [],
                medicines: [],

            },
            medicine: {
                medicineId: null,
                quantity: null,

            },
            service: {
                serviceName: null,
                discount: null,
            },
            indexItem: null,
            headersService: [
                { text: 'اسم الخدمة', value: 'serviceName' },
                { text: 'السعر ', value: 'price' },
                { text: 'التخفيض ', value: 'discount' },
                { text: 'الاجراءات', value: 'actions', sortable: false },
            ],
            headersMedicine: [
                { text: 'اسم العلاج', value: 'medicineId' },
                { text: 'الكمية ', value: 'quantity' },
                { text: 'الاجراءات', value: 'actions', sortable: false },
            ],


        };
    },
    methods: {

        getServices() {
            this.$store.dispatch("lookups/GetItemByProcedure", this.procedureId);
        },
        getPrice() {
            this.service.price = null;
            let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
            this.service.price = service.price;
        },
        confirm() {
            if (this.appointment.services.length == 0) {
                showAlert(`يجب ادخال عنصر واحد على الاقل`);
                return false;
            }
            this.$refs.form.validate().then(valid => {
                if (valid) {
                    var vm = {
                        // doctorRemark: this.appointment.doctorRemark,
                        services: [],
                      medicines:  this.appointment.medicines,
                    };
                    this.appointment.services.forEach(element => {
                        vm.services.push(element);
                    });
                    this.$store
                        .dispatch("doctorsAppointments/edit", { id: this.itemId, payload: vm })
                        .then(() => {
                            this.back();
                        })
                        .catch(() => { });
                } else {
                    showAlert(`الرجاء التحقق من تعبئة جميع الحقول  `);

                }
            })
        },

        back() {
            this.$emit("back");
        },
        AddItem() {
            if (this.service.serviceName == null) {
                showAlert(`يجب اختيار الخدمة `);
                return false;
            }
            if (this.service.price == null) {
                showAlert(`يجب ادخال السعر `);
                return false;
            }
            var Index = this.appointment.services.findIndex(x => x.serviceName == this.service.serviceName);
            if (Index != -1) {
                showAlert(`لا يمكن اضافة نفس الخدمة اكثر من مرة   `);
                return false;
            }
            let service = this.itemPriceList.find(x => x.itemName == this.service.serviceName);
            this.appointment.services.push({
                serviceName: this.service.serviceName,
                serviceCode: service.itemCode,
                price: this.service.price,
                discount: this.service.discount,
            });
            this.service.serviceName = null;
            this.service.price = null;
            this.service.discount = null;
            //this.$refs.info.reset();
        },
        removeItem(index) {
            this.appointment.services.splice(index, 1);
        },
        // ------------------------------------------------------------
        AddMedicineItem() {
            if (this.medicine.medicineId == null) {
                showAlert(`يجب اختيار العلاج `);
                return false;
            }
            if (this.medicine.quantity == null) {
                showAlert(`يجب ادخال الكمية `);
                return false;
            }
            var Index = this.appointment.medicines.findIndex(x => x.medicineId == this.medicine.medicineId);
            if (Index != -1) {
                showAlert(`لا يمكن اضافة نفس العلاج اكثر من مرة   `);
                return false;
            }
            this.appointment.medicines.push({
                medicineId: this.medicine.medicineId,
                quantity: Number(this.medicine.quantity),
            });
            this.medicine.medicineId = null;
            this.medicine.quantity = null;
            //this.$refs.info.reset();
        },
        removeMedicineItem(index) {
            this.appointment.medicines.splice(index, 1);
        },
    },
};
</script>
